/*
 * Lib Module Forms
 */

Lib.Form = (function() {

    //
    let self = {
        formChanged: false
    };

    // Document ready
    $(Lib).on('document.ready', function() {

        // Bind the submitqueued
        self.bindForms();

        // Bind autosubmit
        self.bindAutosubmit($('input[data-autosubmit], select[data-autosubmit]').not('[data-datepicker-options]'));

        // Put autosubmit on a div, any changing element will trigger a submit
        self.bindAutoSubmitDivs($('div[data-autosubmit]'));

        // Convenient data attribute to submit the form with any element
        self.bindSubmit();

        if (Lib.Util.getOption('data.has_validation_errors') === true) {
            let forms = $('form:not(#debug-kit-toolbar form, [data-ignore-form-not-saved])');
            if (forms.length === 1) {
                self.formChanged = true;
                forms.data('formchanged', true);
            }
        }

        $('a:not([href^=\'#\']):not([data-ignore-form-not-saved]):not([target=\'_blank\']), tr[data-rowlink]:not([data-ignore-form-not-saved])').on('click', self.formNotSaved);

        // document.ready in a document ready, because this will make sure it runs as last in the document ready event
        // http://stackoverflow.com/a/11436111/2003600

        $(document).ready(function() {
            $(document).on('change', 'form[data-form-not-saved]', function() {
                self.formChanged = true;
                $(this).data('formchanged', true);
            });
        });

        // Read only checkboxes
        $(document).on('click', 'input:checkbox[readonly]', function(e) {
            e.preventDefault();
            return false;
        });

        self.makeReadonlySelects($('select[readonly]'));

        // Checkboxes that work like radios
        $(document).on('change', 'input:checkbox[data-single-checkbox]', function() {
            if ($(this).is(':checked')) {
                let checkboxIdentifier = $(this).data('single-checkbox');
                $('input:checkbox[data-single-checkbox=\'' + checkboxIdentifier + '\']:checked').not($(this)).prop('checked', 0).trigger('change');
            }
        });

        $(document).on('change', 'input[type="checkbox"][data-select-all]', function() {
            let allSelects = $(this).closest('.input-group.checkboxes').find('input[type="checkbox"]').not($(this));
            if ($(this).is(':checked')) {
                allSelects.prop('checked', 1).triggerHandler('change');
            } else {
                allSelects.prop('checked', 0).triggerHandler('change');
            }
        });

        $(document).on('change', '.input-group.checkboxes.has-select-all input[type="checkbox"]:not([data-select-all])', function() {
            let selectAllCheckbox = $(this).closest('.has-select-all').find('input[data-select-all]');
            let allCheckboxes = $(this).closest('.has-select-all').find('input[type="checkbox"]').not(selectAllCheckbox);

            if (allCheckboxes.filter(':checked').length === allCheckboxes.length) {
                selectAllCheckbox.prop('checked', 1);
            } else {
                selectAllCheckbox.prop('checked', 0);
            }
        });

        // This is for the checkbox that will select the whole group, aka the group selector
        //
        $(document).on('change', 'input[type="checkbox"][data-checkbox-group-master]', function() {
            let currentCheckboxGroup = $(this).data('checkbox-group-master');
            let allCheckboxes = $('input[type="checkbox"][data-checkbox-group="' + currentCheckboxGroup + '"]');
            if ($(this).is(':checked')) {
                allCheckboxes.prop('checked', 1).trigger('change');
            } else {
                allCheckboxes.prop('checked', 0).trigger('change');
            }
        });

        // This is for the checkbox within the group, aka the grouped checkbox
        $(document).on('change', 'input[type="checkbox"][data-checkbox-group]', function() {
            let currentCheckboxGroup = $(this).data('checkbox-group');
            let allCheckboxes = $('input[type="checkbox"][data-checkbox-group="' + currentCheckboxGroup + '"]');
            let checkboxGroupMaster = $('input[type="checkbox"][data-checkbox-group-master="' + currentCheckboxGroup + '"]');
            if (allCheckboxes.filter(':checked').length === allCheckboxes.length) {
                checkboxGroupMaster.prop('checked', 1);
            } else {
                checkboxGroupMaster.prop('checked', 0);
            }
        });

        $(document).on('click', 'input[type="checkbox"]', function(e) {
            if (e.altKey || e.shiftKey) {

                let otherCheckboxesSameName = $('input[name="' + $(this).attr('name') + '"]').not($(this));

                if (!e.shiftKey) {
                    otherCheckboxesSameName.prop('checked', 0).trigger('change');
                    $(this).prop('checked', 1).trigger('change');
                } else {
                    otherCheckboxesSameName.prop('checked', 1).trigger('change');
                    $(this).prop('checked', 0).trigger('change');
                }
            }
        });

        $('input[type="checkbox"][data-checkbox-group]').trigger('change');

        $(document).on('keypress', '[data-disable-submit-on-enter] :input:not(textarea)', function(e) {
            if (e.which === 13) {
                e.preventDefault();
                return false;
            }
        });

        $(document).on('change', '[data-focus-on-change]', function() {

            let focusTarget = $(this).data('focus-on-change');

            if (typeof focusTarget === 'object') {
                switch ($(this).attr('type')) {
                    case 'radio':
                        let checkVal = $(`:input:radio[name='${$(this).attr('name')}']:checked`).val();
                        $(focusTarget[checkVal]).focus().closest('.input-control').addClass('input-focussed');
                        break;
                }
            } else {
                $(focusTarget).focus().closest('.input-control').addClass('input-focussed');
            }
        });
    });

    $(Lib).on('window.load orientation.change', function() {
        self.checkEllipsingCheckboxLabels();
    });

    self.makeReadonlySelects = function(selects) {
        selects.find('option:not(:selected)').prop('disabled', true);

    };
    /**
     *
     */
    self.checkEllipsingCheckboxLabels = function() {
        let tooltipElements = [];
        $('.input-group.checkboxes .checkbox label:truncated').each(function() {
            let text = $(this).text();
            $(this).attr('data-tooltip', text);
            tooltipElements.push($(this));
        });

        Lib.Tooltip.bindTooltips($(tooltipElements));
    };

    /**
     * Form not saved, triggered from clicks on {a} and {tr[data-rowlink]}, passed the click event
     * @returns {boolean}
     */
    self.formNotSaved = function(e) {

        let notSavedForms = self.getNotSavedForms();
        if (self.formChanged && notSavedForms.length) {

            let el = $(this);
            let buttons = {
                'Annuleer': {
                    color: 'blue',
                    close: true
                },
                'Opslaan': {
                    color: 'red',
                    close: true,
                    onClick: function() {
                        notSavedForms.submit();
                    }
                },
                'Verder zonder opslaan': {
                    color: 'red',
                    onClick: function() {

                        // If its a postlink, make a form and submit it
                        if (el.data('postlink')) {
                            self.formChanged = false;
                            el.trigger('click');
                            self.formChanged = true;
                        } else {
                            Lib.Modal.destroy();

                            // Else, we check what tag we have and determine what to do
                            let tag = el.prop('tagName').toLowerCase();
                            switch (tag) {
                                case 'a':
                                    Lib.Loader.onBeforeUnloadLoader = false;
                                    Lib.Util.redirect(el.attr('href'), false, false, (el.attr('target') === '_blank'));
                                    break;
                                default:
                                    el.click();
                            }
                        }
                    }
                }
            };

            if (notSavedForms.length !== 1) {
                delete buttons['Opslaan'];
            } else {
                notSavedForms.each(function() {
                    if ($(this).data('form-not-saved') === 'no-save-button') {
                        delete buttons['Opslaan'];
                        return false;
                    }
                });

            }

            Lib.Modal.confirm({
                title: 'Oeps! Vergeten op te slaan?',
                content: 'Je wijzigingen zijn niet opgeslagen, wat wil je doen?',
                color: 'blue',
                buttons: buttons
            });

            return false;
        }
    };

    self.formNotSavedSubmit = function() {
        let notSavedForms = self.getNotSavedForms();
        if (notSavedForms.length === 1) {
            notSavedForms.submit();
        }
    };

    self.getNotSavedForms = function() {
        return $('form:not(#debug-kit-toolbar form, form[data-ignore-form-not-saved])').filter(function() {
            return ($(this).data('formchanged') === true);
        });
    };

    self.disableEnterSubmit = function(input) {
        input.on('keypress', function(e) {
            return e.which !== 13;
        });
    };

    self.forceEnterSubmit = function(input) {
        input.on('keypress', function(e) {
            if (e.which === 13) {
                input.closest('form').submit();
            }
        });
    };

    /**
     * Bind forms
     */
    self.bindForms = function() {
        $(document).on('submit', 'form:not(#debugkit form)', function(e) {
            $(this).data('submitqueued', true);
            let formData = $(this).data();
            if ('allowedsubmit' in formData && !formData.allowedsubmit) {
                e.preventDefault();
                return false;
            }
        });
    };

    /**
     * Bind autosubmit
     * @param autosubmits
     */
    self.bindAutosubmit = function(autosubmits) {
        autosubmits.on('change', function(e, eventData) {
            if ((eventData && 'autosubmit' in eventData && eventData.autosubmit !== false) || !eventData) {
                e.stopPropagation();
                $(this).closest('form').submit();
            }
        });
    };

    /**
     * Put autosubmit on a div, any changing input will trigger a submit
     * @param divs
     */
    self.bindAutoSubmitDivs = function(divs) {
        self.bindAutosubmit(divs.find(':input'));
    };

    /**
     * Convenient data attribute to submit the form with any element
     */
    self.bindSubmit = function() {

        $(document).on('click', '[data-submit]', function(e) {

            let targetFormSelector = $.trim($(this).data('submit'));
            let targetFormEl = targetFormSelector === '' ? $(this).closest('form') : $(targetFormSelector);

            if (targetFormEl.length === 0) {
                Lib.Debug.warn('Failed to find target form for a [data-submit]');
                return false;
            }

            if ($(this).data('confirm') && !$(this).data('isConfirmed')) {
                return true;
            }

            e.preventDefault();

            let action = $(this).data('submit-action');
            targetFormEl.find('[data-submit-action-input]').remove();

            if (action) {
                targetFormEl.append(Lib.Element.spawn('input', {type: 'hidden', name: '_submit_action', value: action, 'data-submit-action-input': ''}));
            }

            targetFormEl.submit();

        });
    };

    self.fieldError = function(el, msg) {
        if (el instanceof $) {
            let elInputGroup = el.closest('.input-group');
            if (elInputGroup.hasClass('error')) {
                elInputGroup.find('.input-control div[data-js-error]').text(msg);
            } else {
                let error = $('<div />').attr('data-js-error', '').addClass('error-message').text(msg);
                elInputGroup.addClass('error').find('.input-control').append(error);
            }
        } else {

            let field = $('[name$=\'' + el + ']\']');
            if (field.length === 1) {
                self.fieldError(field, msg);
            } else {
                Lib.Debug.warn('You did not provide a jQuery element to Lib.Form.fieldError and it couldnt determine what field you meant');
            }
        }
    };

    self.clearError = function(el) {
        if (el instanceof $) {
            el.closest('.input-group').removeClass('error has-error').find('.input-control .error-message').remove();
        }
    };

    self.clearErrors = function(form) {
        if (form instanceof $) {
            form.find('.error-message[data-js-error]').closest('.input-group').removeClass('has-error error').find('.error-message[data-js-error]').remove();
        }
    };

    /**
     *
     * @param container
     */
    self.resetFieldsInContainer = function(container) {

        // Make texts empty
        container.find('input:text, input:password, textarea').val('').trigger('change');

        // Uncheck checkboxes and radios
        container.find('input:radio, input:checkbox').prop('checked', false).trigger('change');

        // Unselect select options
        container.find('option:selected').prop('selected', false).trigger('change');
    };

    return self;

})();
